var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-12" },
      [
        _vm.step === "area"
          ? _c(
              "div",
              { staticClass: "row gutter-sm" },
              [
                _c(
                  "div",
                  { staticClass: "col-12 text-center text-weight-medium" },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("select_a_area")) +
                        "\n            "
                    )
                  ]
                ),
                _vm._l(_vm.areas, function(area, index) {
                  return _vm.areas.length
                    ? _c(
                        "div",
                        {
                          key: index,
                          staticClass: "col-6",
                          on: {
                            click: function($event) {
                              return _vm.selectArea(area.value)
                            }
                          }
                        },
                        [
                          _c(
                            "q-card",
                            { staticClass: "bg-primary button-style" },
                            [
                              _c(
                                "div",
                                { staticClass: "row q-pl-md q-pt-md" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "col-12 q-mb-sm" },
                                    [
                                      _c("q-icon", {
                                        attrs: {
                                          name: "fal fa-folder-tree",
                                          size: "2rem",
                                          color: "white"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-12 q-subheading text-white"
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(_vm.$t(area.label)) +
                                          "\n                        "
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _c(
                        "div",
                        { staticClass: "col-12" },
                        [
                          _c(
                            "q-card",
                            {
                              staticClass: "bg-primary button-style",
                              nativeOn: {
                                click: function($event) {
                                  return _vm.selectArea("all")
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "row q-pl-md q-pt-md" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "col-12 q-mb-sm" },
                                    [
                                      _c("q-icon", {
                                        attrs: {
                                          name: "fal fa-folder-tree",
                                          size: "2rem",
                                          color: "white"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-12 q-subheading text-white"
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(_vm.$t("all_f")) +
                                          "\n                        "
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      )
                }),
                _vm.groups_user.length > 0 && _vm.isPopOrSeven
                  ? _c(
                      "div",
                      { staticClass: "col-12 text-center text-weight-medium" },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.$t("select_a_group")) +
                            "\n            "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm.isPopOrSeven
                  ? _vm._l(_vm.groups_user, function(group, index) {
                      return _c(
                        "div",
                        {
                          key: index + "-g",
                          staticClass: "col-6",
                          on: {
                            click: function($event) {
                              return _vm.selectGroup(group.value)
                            }
                          }
                        },
                        [
                          _c(
                            "q-card",
                            { staticClass: "bg-primary button-style" },
                            [
                              _c(
                                "div",
                                { staticClass: "row q-pl-md q-pt-md" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "col-12 q-mb-sm" },
                                    [
                                      _c("q-icon", {
                                        attrs: {
                                          name: "fal fa-folder-tree",
                                          size: "2rem",
                                          color: "white"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-12 q-subheading text-white"
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(_vm.$t(group.label)) +
                                          "\n                            "
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    })
                  : _vm._e()
              ],
              2
            )
          : _vm._e(),
        _vm.step === "category"
          ? _c(
              "div",
              { staticClass: "row gutter-sm" },
              [
                _c(
                  "div",
                  { staticClass: "col-12 text-center text-weight-medium" },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("select_a_category")) +
                        "\n            "
                    )
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c(
                      "q-card",
                      {
                        staticClass: "bg-primary button-style",
                        nativeOn: {
                          click: function($event) {
                            return _vm.selectCategory("all")
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "row q-pl-md q-pt-md" }, [
                          _c(
                            "div",
                            { staticClass: "col-12 q-mb-sm" },
                            [
                              _c("q-icon", {
                                attrs: {
                                  name: "fal fa-folder-tree",
                                  size: "2rem",
                                  color: "white"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-12 q-subheading text-white" },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.$t("all_f")) +
                                  "\n                        "
                              )
                            ]
                          )
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _vm._l(_vm.categories, function(category, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "col-6",
                      on: {
                        click: function($event) {
                          return _vm.selectCategory(category.value)
                        }
                      }
                    },
                    [
                      _c("q-card", { staticClass: "bg-primary button-style" }, [
                        _c("div", { staticClass: "row q-pl-md q-pt-md" }, [
                          _c(
                            "div",
                            { staticClass: "col-12 q-mb-sm" },
                            [
                              _c("q-icon", {
                                attrs: {
                                  name: category.icon,
                                  size: "2rem",
                                  color: "white"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-12 q-subheading text-white" },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.$t(category.label)) +
                                  "\n                        "
                              )
                            ]
                          )
                        ])
                      ])
                    ],
                    1
                  )
                }),
                _c(
                  "div",
                  { staticClass: "col-12 text-center" },
                  [
                    _c("q-btn", {
                      attrs: {
                        label: _vm.$t("select_area"),
                        color: "tertiary",
                        icon: "fal fa-chevron-left"
                      },
                      on: {
                        click: function($event) {
                          return _vm.backToArea()
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              2
            )
          : _vm._e(),
        _vm.step === "tags"
          ? _c(
              "div",
              { staticClass: "row gutter-sm" },
              [
                _c(
                  "div",
                  { staticClass: "col-12 text-center text-weight-medium" },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("select_tags")) +
                        "\n            "
                    )
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c(
                      "q-card",
                      {
                        staticClass: "bg-primary button-style",
                        nativeOn: {
                          click: function($event) {
                            return _vm.selectTags("all")
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "row q-pl-md q-pt-md" }, [
                          _c(
                            "div",
                            { staticClass: "col-12 q-mb-sm" },
                            [
                              _c("q-icon", {
                                attrs: {
                                  name: "fal fa-sort-amount-down-alt",
                                  size: "2rem",
                                  color: "white"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-12 q-subheading text-white" },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.$t("none")) +
                                  "\n                        "
                              )
                            ]
                          )
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _vm._l(_vm.tags, function(tag, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "col-12" },
                    [
                      _c(
                        "q-card",
                        {
                          staticClass: "bg-primary",
                          nativeOn: {
                            click: function($event) {
                              return _vm.selectTags(tag.value)
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "row q-pl-md q-py-md" }, [
                            _c(
                              "div",
                              { staticClass: "col-12 q-subheading text-white" },
                              [
                                _c("q-checkbox", {
                                  staticClass: "checkbox-filter",
                                  attrs: {
                                    val: tag.value,
                                    label: tag.label,
                                    color: "white"
                                  },
                                  model: {
                                    value: _vm.selected_tags,
                                    callback: function($$v) {
                                      _vm.selected_tags = $$v
                                    },
                                    expression: "selected_tags"
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  )
                }),
                _c(
                  "div",
                  { staticClass: "col-12 text-center" },
                  [
                    _c("q-btn", {
                      staticClass: "full-width",
                      attrs: {
                        color: "secondary",
                        label: _vm.$t("apply_filter"),
                        icon: "fal fa-filter"
                      },
                      on: {
                        click: function($event) {
                          return _vm.applyFilter()
                        }
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-12 text-center" },
                  [
                    _c("q-btn", {
                      attrs: {
                        label: _vm.$t("select_category"),
                        color: "tertiary",
                        icon: "fal fa-chevron-left"
                      },
                      on: {
                        click: function($event) {
                          return _vm.backToCategory()
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              2
            )
          : _vm._e(),
        _vm.step === "showing_files"
          ? _c(
              "q-list",
              { staticClass: "bg-white" },
              [
                _c(
                  "q-collapsible",
                  {
                    staticClass: "filter",
                    attrs: {
                      icon: "fal fa-filter",
                      label: _vm.$t("filter"),
                      opened: !_vm.$q.platform.is.mobile ? true : false
                    }
                  },
                  [
                    _c(
                      "q-list",
                      { attrs: { "no-border": "" } },
                      [
                        _c(
                          "q-item",
                          [
                            _c(
                              "q-item-main",
                              [
                                _c("q-search", {
                                  attrs: {
                                    placeholder: _vm.$t("search"),
                                    icon: "fal fa-search",
                                    debounce: 600
                                  },
                                  on: {
                                    input: function($event) {
                                      return _vm.changeFilter("search")
                                    }
                                  },
                                  model: {
                                    value: _vm.search,
                                    callback: function($$v) {
                                      _vm.search = $$v
                                    },
                                    expression: "search"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "q-list",
                      { attrs: { "no-border": "", link: "" } },
                      [
                        _c("q-list-header", [
                          _vm._v(_vm._s(_vm.$t("extensions")))
                        ]),
                        _vm._l(_vm.extensions, function(extension, index) {
                          return _c(
                            "q-item",
                            { key: index, attrs: { tag: "label" } },
                            [
                              _c(
                                "q-item-side",
                                [
                                  _c("q-checkbox", {
                                    attrs: { val: extension },
                                    on: {
                                      input: function($event) {
                                        return _vm.changeFilter("extension")
                                      }
                                    },
                                    model: {
                                      value: _vm.selected_extensions,
                                      callback: function($$v) {
                                        _vm.selected_extensions = $$v
                                      },
                                      expression: "selected_extensions"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "q-item-main",
                                [
                                  _c(
                                    "q-item-tile",
                                    {
                                      staticClass:
                                        "text-weight-light uppercase",
                                      attrs: { label: "" }
                                    },
                                    [
                                      _c("q-icon", {
                                        attrs: {
                                          name: _vm.$extensionIcon(extension),
                                          size: "1.5rem"
                                        }
                                      }),
                                      _vm._v(
                                        " " +
                                          _vm._s(extension) +
                                          "\n                            "
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        })
                      ],
                      2
                    )
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _vm.step !== "area"
          ? _c("div", { staticClass: "row gutter-sm q-my-sm" }, [
              _c("div", { staticClass: "col-12 text-center" }, [
                _c(
                  "span",
                  {
                    staticClass: "cursor-pointer",
                    on: {
                      click: function($event) {
                        return _vm.clearFilters()
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("restart_filters")) +
                        "\n                "
                    )
                  ]
                )
              ])
            ])
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }